import React from 'react';
import { QRCode } from '@/components/QRCode';
import { useAuthState } from '@/utils/auth';
import { UserQRInputData, getUserQRData } from './getUserQRData';
import { Skeleton } from './ui/skeleton';

export type UserQRProps = {
  user?: UserQRInputData;
  size?: number;
  className?: string;
};

export const UserQR: React.FC<UserQRProps> = ({ user, size, className }) => {
  const { user: myUser } = useAuthState();
  if (!user && !myUser) return <Skeleton className="size-64" />;
  return (
    <QRCode
      value={JSON.stringify(getUserQRData(user ?? (myUser as any)))}
      size={size}
      alt="User's QR code"
      className={className}
    />
  );
};
